<template>
<validation-observer ref="SignalProtocolsEventCodeForm" class="form">
    <form ref="form" class="form">
        <validation-provider
        :name="$t('defination.eventCodes.form.event_code')"
        :rules="{ required: true }"
        v-slot="validationContext"
        >
        <b-row>
            <b-col sm="4"> <label for="event_code"> {{$t('defination.eventCodes.form.event_code')}} </label> </b-col>
            <b-col sm="8"> 
                <b-form-input id="event_code" v-model="event_code" :placeholder="$t('defination.eventCodes.formPlaceholder.event_code')" 
                :state="getValidationState(validationContext)"
                aria-describedby="live-feedback"
                />
                        <template slot="singleLabel" slot-scope="{ option }">
                            <strong>{{ option.text }} </strong> 
                        </template>
                <b-form-invalid-feedback id="live-feedback">{{
                    validationContext.errors[0]
                }}</b-form-invalid-feedback>
            </b-col>
        </b-row>
        </validation-provider>
        <validation-provider
        :name="$t('defination.eventCodes.form.alarm')"
        :rules="{ required: true }"
        v-slot="validationContext"
        >
        <b-row>
            <b-col sm="4"> <label for="is_alarm"> {{$t('defination.eventCodes.form.alarm')}} </label> </b-col>
            <b-col sm="4"> 
            <b-form-radio-group
                id="is_alarm"
                v-model="is_alarm"
                :options="isAlarmOptions"
                aria-describedby="live-feedback"
                name="is_alarm"
                :state="getValidationState(validationContext)"
            ></b-form-radio-group>
                <b-form-invalid-feedback id="live-feedback">{{
                    validationContext.errors[0]
                }}</b-form-invalid-feedback>
            </b-col>
        </b-row>
        </validation-provider>
        <validation-provider
        :name="$t('defination.eventCodes.form.signal_type')"
        :rules="{ required: true }"
        v-slot="validationContext"
        >
        <b-row>
            <b-col sm="4"> <label for="signalType"> {{$t('defination.eventCodes.form.signal_type')}} </label> </b-col>
            <b-col sm="8"> 
                <Multiselect  
                    v-model="signalType"
                    :show-labels="false" 
                    :options="data.signalTypes?data.signalTypes:[]"
                    label="text"
                    track-by="ID"
                    :state="getValidationState(validationContext)"
                    aria-describedby="live-feedback"
                    :placeholder="$t('general.select')"
                    id="signalType"
                    >
                        <template slot="singleLabel" slot-scope="{ option }">
                            <strong>{{ option.text }} </strong> 
                        </template>
                </Multiselect>
                <b-form-invalid-feedback id="live-feedback">{{
                    validationContext.errors[0]
                }}</b-form-invalid-feedback>
            </b-col>
        </b-row>
        </validation-provider>
    </form>
</validation-observer>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import i18n from "@/plugins/i18n";
    let isAlarmOptions = [
        { text:i18n.t('general.yes'), value:true },
        { text:i18n.t('general.no'), value:false }
    ]
    export default {
        name: "SignalProtocolsEventCodeForm",
        data(){
            return {
                isAlarmOptions,
                signalType: this.data.item ? this.data.signalTypes.find(signalType=>signalType.ID === this.data.item.signal_types.ID) : null,
                event_code: this.data.item ? this.data.item.event_code : "",
                is_alarm: this.data.item ? this.data.item.is_alarm : null,
                signal_type_id: this.data.item ? this.data.item.signal_types.ID : null,
                errMsg: ""
            }
        },
        props: {
            data: Object,
            changeData: Function,
            save: Boolean,
            saveState: Function,
            modalName: String,
            modalEvent: Function
        },
        components:{
            Multiselect
        },
        methods: {
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
        clearForm() {
            this.signalType = null,
            this.event_code = "",
            this.is_alarm = null,
            this.signal_type_id = null,
            this.errMsg = ""
            this.modalEvent(false);
        }
      },
        watch: {
            signalType(val) {
                if (val){
                    this.signal_type_id = val.ID
                } else {
                    this.signal_type_id = null
                }
            },
            save: async function(data) {
                if (data) {
                    this.$refs.SignalProtocolsEventCodeForm.validate().then(async success => {
                    if (success){
                    let val = {
                        event_code: this.event_code,
                        is_alarm: this.is_alarm,
                        signal_protocol_id: this.data.selectedProtocol,
                        signal_type_id: this.signal_type_id
                    }
                    switch (this.modalName) {
                    case "addEventCode":
                        await this.$store.dispatch("addEventCodes", val);
                        break;
                    case "editEventCode":
                        val.id = this.data.item.id
                        await this.$store.dispatch("editEventCodes", val);
                        break;
                    }
                    if (this.$store.getters.getAddressStatus.status == "Success") {
                    this.$store.dispatch("listEventCodes",{protocol:this.data.selectedProtocol});
                    this.clearForm();
                    } else {
                    this.errMsg = i18n.t("general.addErrMsg");
                    }
                    }
                    })
                    this.saveState(false);
                }
            }
        }
    }
</script>

<style lang="css" scoped > 
    @import "../styles/modalForm.min.css"; 
    @import "../styles/modal.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/SignalProtocolsEventCodeForm.vue